import type { ScopeRef } from "@/components/scope-picker/types";

export function encodeScope(s: ScopeRef): string {
	switch (s.type) {
		case "org":
			return "org";
		case "wlasne":
			return "wlasne";
		case "franczyza":
			return "franczyza";
		case "region":
			return `region:${s.id ?? ""}`;
		case "spolka":
			// V5: s.id to znormalizowany NIP-string, nie liczba.
			return `spolka:${s.id}`;
		case "apteka":
			return `apteka:${s.id}`;
		case "orphan":
			return `orphan:${s.id ?? ""}`;
		case "kr":
			// Surowa nazwa; URL-encoding robi warstwa search params / URLSearchParams.
			return `kr:${s.id}`;
	}
}

export function decodeScope(raw: string): ScopeRef | null {
	if (raw === "org") return { type: "org" };
	if (raw === "wlasne") return { type: "wlasne" };
	if (raw === "franczyza") return { type: "franczyza" };
	const idx = raw.indexOf(":");
	if (idx < 0) return null;
	const kind = raw.slice(0, idx);
	const id = raw.slice(idx + 1);
	if (kind === "region") return { type: "region", id: id === "" ? null : id };
	if (kind === "orphan") return { type: "orphan", id: id === "" ? null : id };
	if (kind === "spolka") {
		if (!/^[0-9 -]+$/.test(id)) return null;
		const normalized = id.replace(/[^0-9]/g, "");
		return normalized === "" ? null : { type: "spolka", id: normalized };
	}
	if (kind === "apteka") {
		const n = Number(id);
		if (!Number.isFinite(n)) return null;
		return { type: "apteka", id: n };
	}
	if (kind === "kr") {
		// Lustro backendowego parsera: TRIM, pusta nazwa = token nieprawidłowy.
		const name = id.trim();
		return name === "" ? null : { type: "kr", id: name };
	}
	return null;
}

/**
 * Task 7.3: rozbij ScopeRef na (scopeType, scopeValue) — format wymagany przez
 * write-side endpointy (visibility_rules, assignment APIs). Symetrycznie do
 * encodeScope/decodeScope, ale zwraca strukturalna pare zamiast stringa.
 */
export function scopeToWriteParts(s: ScopeRef): { scopeType: string; scopeValue: string } {
	switch (s.type) {
		case "org":
			return { scopeType: "org", scopeValue: "" };
		case "wlasne":
			return { scopeType: "wlasne", scopeValue: "" };
		case "franczyza":
			return { scopeType: "franczyza", scopeValue: "" };
		case "region":
			return { scopeType: "region", scopeValue: s.id ?? "" };
		case "spolka":
			return { scopeType: "spolka", scopeValue: s.id };
		case "apteka":
			return { scopeType: "apteka", scopeValue: String(s.id) };
		case "orphan":
			return { scopeType: "orphan", scopeValue: s.id ?? "" };
		case "kr":
			return { scopeType: "kr", scopeValue: s.id };
	}
}
